import { restApi } from '../../api';
import { UploadOptions, UploadOutput } from './upload.types';

const PATH = 'upload';

export const upload = (formData: FormData, { width }: UploadOptions = {}) =>
  restApi.post<UploadOutput>(width !== undefined ? `${PATH}?width=${width}` : PATH, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
